import {
  Box,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import { maskPhone } from "../../../utils/maskFields";
import { ICONS } from "../pdfPreview/icons/icons";
import { useMemo } from "react";
interface HeaderConfigProps {
  config: EasyReportConfig | undefined;
  setConfig: (config: EasyReportConfig) => void;
  setHasChanges: (value: boolean) => void;
}

const HeaderConfig = ({
  config,
  setConfig,
  setHasChanges,
}: HeaderConfigProps) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const configuracao = useMemo(
    () => config?.configuracoes,
    [config?.configuracoes],
  );

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string,
  ) => {
    if (config) {
      setConfig({
        ...config,
        configuracoes: {
          ...configuracao,
          [key]: key === "phone" ? maskPhone(e.target.value) : e.target.value,
        },
      });
    } else {
      setConfig({
        nome: "header",
        configuracoes: {
          [key]: key === "phone" ? maskPhone(e.target.value) : e.target.value,
        },
      });
    }
    setHasChanges(true);
  };

  return (
    <>
      <Paper variant="outlined" sx={styles.boxPreview}>
        <Box>
          {configuracao?.imgLink && (
            <img
              src={configuracao.imgLink}
              alt="Imagem do cabeçalho"
              style={{
                maxWidth: 150,
                maxHeight: 85,
              }}
            />
          )}
        </Box>
        <Box sx={styles.boxLine}>
          <Typography sx={styles.textPreview}>
            {configuracao?.email && (
              <>
                <img src={ICONS.email} alt="Email" style={styles.icon} />
                {configuracao?.email}
              </>
            )}
          </Typography>
          <Typography sx={styles.textPreview}>
            {configuracao?.phone && (
              <>
                <img src={ICONS.phone} alt="Telefone" style={styles.icon} />
                {configuracao?.phone}
              </>
            )}
          </Typography>
          <Typography sx={styles.textPreview}>
            {configuracao?.instagram && (
              <>
                <img
                  src={ICONS.instagram}
                  alt="Instagram"
                  style={styles.icon}
                />
                {configuracao?.instagram}
              </>
            )}
          </Typography>
        </Box>
      </Paper>
      <Paper variant="outlined" sx={{ ...styles.boxOP, gap: 0 }}>
        <Typography sx={styles.text}>Cabeçalho</Typography>
        <Typography sx={{ ...styles.textFine, mb: 1 }}>
          Insira as informações que deseja exibir no cabeçalho do relatório.
        </Typography>
        <TextField
          fullWidth
          type="email"
          sx={styles.textField}
          size="small"
          value={configuracao?.email ?? ""}
          onChange={(e) => handleChange(e, "email")}
          slotProps={{
            input: {
              inputProps: {
                maxLength: 60,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography sx={styles.textAdorment}>EMAIL</Typography>
                </InputAdornment>
              ),
            },
          }}
        />
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={1}
          sx={{ width: "100%", mb: 2 }}
        >
          <TextField
            fullWidth
            type="tel"
            sx={styles.textField}
            size="small"
            value={configuracao?.phone ?? ""}
            onChange={(e) => handleChange(e, "phone")}
            slotProps={{
              input: {
                inputProps: {
                  maxLength: 15,
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={styles.textAdorment}>TELEFONE</Typography>
                  </InputAdornment>
                ),
              },
            }}
          />
          <TextField
            fullWidth
            type="text"
            sx={styles.textField}
            size="small"
            value={configuracao?.instagram ?? ""}
            onChange={(e) => handleChange(e, "instagram")}
            slotProps={{
              input: {
                inputProps: {
                  maxLength: 90,
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={styles.textAdorment}>INSTAGRAM</Typography>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Stack>
        <TextField
          fullWidth
          type="url"
          sx={styles.textField}
          size="small"
          value={configuracao?.imgLink ?? ""}
          onChange={(e) => handleChange(e, "imgLink")}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Typography sx={styles.textAdorment}>IMAGEM</Typography>
                </InputAdornment>
              ),
            },
          }}
        />
      </Paper>
      {/* <Paper
        variant={theme.palette.mode === "dark" ? "outlined" : undefined}
        sx={styles.previewContainer}
      > */}
      {/* <Box sx={styles.boxPreview}>
        <Box>
          {configuracao?.imgLink && (
            <img
              src={configuracao.imgLink}
              alt="Imagem do cabeçalho"
              style={{
                maxWidth: 150,
                maxHeight: 85,
              }}
            />
          )}
        </Box>
        <Box sx={styles.boxLine}>
          <Typography sx={styles.textPreview}>
            {configuracao?.email && (
              <>
                <img src={ICONS.email} alt="Email" style={styles.icon} />
                {configuracao?.email}
              </>
            )}
          </Typography>
          <Typography sx={styles.textPreview}>
            {configuracao?.phone && (
              <>
                <img src={ICONS.phone} alt="Telefone" style={styles.icon} />
                {configuracao?.phone}
              </>
            )}
          </Typography>
          <Typography sx={styles.textPreview}>
            {configuracao?.instagram && (
              <>
                <img
                  src={ICONS.instagram}
                  alt="Instagram"
                  style={styles.icon}
                />
                {configuracao?.instagram}
              </>
            )}
          </Typography>
        </Box>
      </Box> */}
      {/* </Paper> */}
    </>
  );
};

export default HeaderConfig;
